import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { useLogEvent } from '~/hooks/useLogEvent'

import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { useCreateStrategyMemoMutation } from '../hooks/useCreateStrategyMemoMutation'

export const CreateButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const brandAccountId = useBrandAccountId()
  const logEvent = useLogEvent()
  const createStrategyMemoMutation = useCreateStrategyMemoMutation({
    onSuccess: (strategyMemoId) => {
      navigate(compile('strategyMemoEdit', { brandAccountId, strategyMemoId }))
      logEvent('Create customer strategy')
    },
  })

  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    createStrategyMemoMutation.mutate()
  }, [createStrategyMemoMutation])

  return (
    <StyledButton
      buttonStyle="success"
      disabled={createStrategyMemoMutation.isPending}
      fillMode="outline"
      icon="add"
      onClick={handleClick}
    >
      {t('create_new_2')}
    </StyledButton>
  )
}
